function PersonalToken(core) {
    this.client = core.client;
}

const baseUrl = '../api/v1/personal/token/';

Object.assign(PersonalToken.prototype, {
    namespace: 'PersonalToken',
    get(params) {
        return this.client.send('GET', baseUrl, params);
    }
});

export default PersonalToken;
